<template>
    <div class="admin-clients-page">
        <button-component
                class="new-client-button"
                @click.native="addNewClient()">
            Cliënt toevoegen
        </button-component>
        <ul>
            <listitem-component
                    v-for="client in getAllClients"
                    :key="client.id"
                    @click.native="editClient(client)">
                {{ client.initials }}
            </listitem-component>
            <p v-if="getAllClients.length < 1">Er zijn nog geen cliënten toegevoegd</p>
        </ul>
    </div>
</template>

<script>
import { RouteName } from '../../utils/enums';
import ListitemComponent from '../../components/listitem.component';
import ButtonComponent from '../../components/button.component.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'admin-clients-page',
    components: {
        ListitemComponent,
        ButtonComponent
    },
    computed: {
        ...mapGetters(['getAllClients']),
    },
    created() {
        this.$store.dispatch('FETCH_CLIENTS');
        this.$store.dispatch('FETCH_ALL_LOCATIONS');
    },
    methods: {
        editClient(client) {
            this.$store.commit('SET_CLIENT_TO_EDIT', client);
            this.$router.push({ name: RouteName.ADMIN_EDIT_CLIENT });
        },
        addNewClient() {
            this.$router.push({ name: RouteName.ADMIN_NEW_CLIENT });
        }
    }
};
</script>

<style scoped lang="scss">
    .listitem-component::v-deep {
        .listitem-icon {
            background-image: url('../../assets/icons/pofile-medium-white.svg');
            background-position-y: 12px;
        }
    }
    .new-client-button {
        margin-bottom: 1rem;
    }
</style>
